export default __webpack_public_path__ + "static/media/EngineeringTunnels_09.08af1114.png";